import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import Layout from "../components/Layout";
import Steps, { stepIndexOf } from "../components/Steps";
import docusignService from "../services/docusign.service";

// #65 - landing page after signing the request's release letter. DocuSign (or the
// mock) redirects here with a full-page navigation, so the wizard's in-memory
// state is gone. We confirm the release status with the server, rehydrate the
// wizard from the stored payload, and drop the agent back on the Carrier Release
// step with the release marked signed, so they can continue.
const ReleaseSigningReturn = () => {
  const { id } = useParams();
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    docusignService
      .getReleaseStatus(id)
      .then((res) => setState({ loading: false, ...res }))
      .catch(() =>
        setState({ loading: false, error: "We couldn't confirm your signature." })
      );
  }, [id]);

  if (state.loading) {
    return (
      <Layout>
        <Box sx={{ padding: 4, display: "flex", justifyContent: "center" }}>
          <Stack spacing={2} alignItems="center" sx={{ mt: 6 }}>
            <CircularProgress />
            <Typography variant="body1" color="text.secondary">
              Confirming your release signature...
            </Typography>
          </Stack>
        </Box>
      </Layout>
    );
  }

  // The request's single release: true once the release envelope is completed.
  const releaseSigned = !!state.release?.completed;
  const payload = { ...(state.payload || {}), releaseSigned };
  const carrierReleaseStep = stepIndexOf(payload, "Carrier Release") || 1;

  return (
    <Layout>
      <Box sx={{ padding: 4 }}>
        <Steps
          initialData={payload}
          initialStep={carrierReleaseStep}
          unsignedId={id}
        />
      </Box>
    </Layout>
  );
};

export default ReleaseSigningReturn;
